import {displayPhoneNumber} from 'Src/utilities/Helpers'
import {
  getResolvedSellingPrice,
  isSellingPriceMissingOrZero,
  mergeVehicleRecords,
} from 'Src/utilities/vehicleSellingPrice'

/** Existing Error page generic copy. */
export const getGenericErrorPageMessage = (dealershipPhone?: string | null) => {
  if (dealershipPhone) {
    return `We received your request, but it looks like something went wrong at our end. Don't worry, we can still help! Please call us at ${displayPhoneNumber(
      dealershipPhone
    )} or complete the form below and we will follow up with you.`
  }

  return "We received your request, but it looks like something went wrong at our end. Don't worry, we can still help! Please call us or complete the form below and we will follow up with you."
}

/** Existing Error page price-unavailable copy. */
export const getPriceUnavailableErrorPageMessage = (dealershipPhone?: string | null) => {
  if (dealershipPhone) {
    return `A price is unavailable for this vehicle. Please call us at ${displayPhoneNumber(
      dealershipPhone
    )} for pricing information or complete the form below and we will follow up with you.`
  }

  return 'A price is unavailable for this vehicle. Please call us for pricing information or complete the form below and we will follow up with you.'
}

/**
 * Resolves user-facing error copy using the same rules as Error.tsx.
 * Used by the error page and the registration deferred-error banner.
 */
export const resolveErrorPageMessage = ({
  dealershipPhone,
  vehicle,
  embedVehicle,
  deferredErrorCause,
  originalMessage,
}: {
  dealershipPhone?: string | null
  vehicle?: Record<string, unknown> | null
  embedVehicle?: Record<string, unknown> | null
  deferredErrorCause?: string | null
  originalMessage?: string | null
} = {}): string => {
  const useCustomUrlMessage =
    originalMessage &&
    !originalMessage.includes('Please try again later') &&
    !originalMessage.includes('Vehicle not in inventory')

  const mergedVehicle = mergeVehicleRecords(vehicle, embedVehicle) as Record<string, unknown>
  const sellingPrice = getResolvedSellingPrice(mergedVehicle)

  const hasVehicleContext = Boolean(
    mergedVehicle.vin || mergedVehicle.stock || mergedVehicle.stock_number
  )

  const hasLoadedVehicleFromApi = Boolean(vehicle?.id)

  const showPriceUnavailable =
    !useCustomUrlMessage &&
    hasVehicleContext &&
    (hasLoadedVehicleFromApi || deferredErrorCause === 'no_selling_price') &&
    isSellingPriceMissingOrZero(sellingPrice)

  if (useCustomUrlMessage && originalMessage) {
    return originalMessage
  }

  if (showPriceUnavailable) {
    return getPriceUnavailableErrorPageMessage(dealershipPhone)
  }

  return getGenericErrorPageMessage(dealershipPhone)
}
